import { Routes } from "@angular/router";
import { SellerComponent } from "src/app/seller/seller/seller.component";
import { SellerproductsComponent } from "src/app/seller/sellerproducts/sellerproducts.component";

export const PARTNER_ROUTES: Routes = [
    {
        path: 'partner/info/:id', component: SellerComponent
    },
    {
        path: 'partner/:id', component: SellerproductsComponent
    }
]